export function formatDias(valor) {
  const num = parseFloat(valor) || 0;
  if (Number.isInteger(num)) {
    return `${num}d`;
  }
  const formatado = num.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
  return `${formatado.replace('.', ',')}d`;
}